import { WeaTools } from 'ecCom'

export const getKQCarendarReport = params => {
  return WeaTools.callApi('/api/hrm/kq/schedule/getHrmScheduleReportInfo', 'POST', params);
}



// WEBPACK FOOTER //
// ../src4js/pc4mobx/hrm/apis/shift.js